export function getFileNameWithoutExtension(fileName) {
    if (!fileName) return "";
    // Remove the extension (everything after the last dot)
    return fileName.replace(/\.[^/.]+$/, "");
}